import { Controller } from "stimulus";

class MiniCartController extends Controller {
  static values = {
    itemsInCart: Number,
  };

  static targets = ["cartItems", "cartItemsList"];

  #itemsInCartQuantity = this.itemsInCartValue;

  connect() {
    this.#handleCounter(this.itemsInCartValue);
    document.addEventListener("click", this.#handleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.#handleClickOutside);
  }

  #updateQuantity(quantity, shouldOverrideQuantity) {
    if (shouldOverrideQuantity) {
      this.#itemsInCartQuantity = quantity;
    } else {
      this.#itemsInCartQuantity += parseInt(quantity);
    }

    return this.#handleCounter(this.#itemsInCartQuantity);
  }

  #handleCounter(itemsInCart) {
    if (itemsInCart === 0) {
      return this.cartItemsTarget.classList.add("tw-hidden");
    }

    this.cartItemsTarget.classList.remove("tw-hidden");
    this.cartItemsTarget.textContent = itemsInCart;
  }

  #handleClickOutside = (event) => {
    const isVisible =
      this.cartItemsListTarget.classList.contains("tw-opacity-1");

    if (!isVisible) return;

    if (!this.element.contains(event.target)) {
      this.toggleMiniCartVisibility();
    }
  };

  #scrollToLatestAddedItem = (id) => {
    const latestAddedItem = this.cartItemsListTarget.querySelector(
      `[data-item-id="${id}"]`,
    );
    if (latestAddedItem) {
      latestAddedItem.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };

  toggleMiniCartVisibility(e) {
    e?.preventDefault();

    const classesToToggle = [
      "tw-opacity-0",
      "tw-pointer-events-none",
      "tw-opacity-1",
      "tw-pointer-events-auto",
    ];

    classesToToggle.forEach((className) => {
      this.cartItemsListTarget.classList.toggle(className);
    });
  }

  async #fetchMiniCartData() {
    const url = `${window.Shopify.routes.root}?view=mini-cart`;

    const response = await fetch(url);
    return response.text();
  }

  async updateCart(event) {
    const { quantity, shouldOverrideQuantity, hideMiniCart, id } = event.detail;

    this.#updateQuantity(quantity, shouldOverrideQuantity);

    this.cartItemsListTarget.innerHTML = await this.#fetchMiniCartData();

    this.#scrollToLatestAddedItem(id);

    if (!hideMiniCart) {
      this.toggleMiniCartVisibility();
    }
  }

  async deleteItem(event) {
    const response = await fetch(event.detail.url, {
      headers: { Accept: "application/json" },
    });

    if (response.ok) {
      const { item_count } = await response.json();

      if (item_count === 0) {
        this.toggleMiniCartVisibility();
      }

      this.cartItemsListTarget.innerHTML = await this.#fetchMiniCartData();

      return this.#updateQuantity(item_count, true);
    }

    return console.error(response);
  }
}

Stimulus.register("miniCart", MiniCartController);
